 import styles from "../../pages/sch-test/delhi-prefit.module.css";
 import ReCAPTCHA from "react-google-recaptcha";
 import { MultiSelect } from "react-multi-select-component";
 import { tnpscnewuser } from "../Service/tnpscmainsmocktest";
 import { tnpscmailcnfm } from "../Service/tnpscmainsmocktest";
 import { useState } from "react";
 import dynamic from 'next/dynamic';
import Otpverification from "../Modal/Otpverification";

 export const NewStudentForm = () =>{
 
     const  options  = [
         { value: 'IMTOP-TNPSC-Group-I-Prelims-Test-Series', label: 'IMTOP TNPSC Group I Prelims Test Series' },
         { value: 'IMTOP-TNPSC-Group-I-Mains-Test-Series', label: 'IMTOP TNPSC Group I Mains Test Series' },
         { value: 'TNPSC-GroupII/IIA-Prelims-TestSeries', label: 'TNPSC Group II/IIA Prelims Test Series' },
         { value: 'IMTOP-TNPSC-Group-II-Mains-Test-Series', label: 'IMTOP TNPSC Group II Mains Test Series' },
         { value: 'IMTOP-TNPSC-Group-IIA-Mains-Test-Series', label: 'IMTOP TNPSC Group IIA Mains Test Series' },
         { value: 'TNPSC-Group-IV-Test-Series', label: 'TNPSC Group IV Test Series' },
         { value: 'TNPSC-Group-IV-Class-cum-Workshop', label: 'TNPSC Group IV Class cum Workshop' },
         { value: 'TNPSC-Group-I/II-Prelims–Regular Programme', label: 'TNPSC Group I/II Prelims – Regular Programme' },
         { value: 'TNPSC-PCM-Batch', label: 'TNPSC Group I PCM – Regular Programme' },
         { value: 'TNPSC-Group-I-Interview-Programme', label: 'TNPSC Group I Interview Programme' },
        // { value: 'GroupII-Mains-CrashCourse', label: 'TNPSC Group II Mains Crash Course' },
         { value: 'UPSC-PCM', label: 'UPSC PCM' },
         { value: 'UPSC-Optional', label: 'UPSC Optional' },

       ]
     const [verified, setverified] = useState(false);
     const [isLoading, setIsLoading] = useState(false);
     const [modalOtp, setModalOtp] = useState(false); 
     const [modalOtpstatus, setmodalOtpstatus] = useState(null);
     const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
     const [valuephno, setvaluephno] = useState(undefined);
     const [captchaerror, setcaptchaerror] = useState(undefined);
     const [selectedRadio, setSelectedRadio] = useState();
     const [imgerror, setimgerror] = useState(undefined);
     const [base64ImageToUpload, setbase64ImageToUpload] = useState();
     const [pdfError, setPdfError] = useState(false);
     const [base64PdfToUpload, setbase64PdfToUpload] = useState();
     const [fileName, setFileName] = useState("");
     const [pdfName, setPdfName] = useState("");
     const [selected, setSelected] = useState([]);
     const [formData, setFormData] = useState({ selectedData: '' });
     const [paymentData, setPaymentData] = useState([]); 
     
 
   const handleChange = (selectedOptions) => {
     setSelected(selectedOptions);
 
     // Convert selected options to JSON string
     const jsonString = JSON.stringify(selectedOptions.map(option => option.value));
     const jsonString2=JSON.parse(jsonString);
     
     // Update the formData state with the comma-separated values
     setFormData({selectedData: jsonString2 });
 };
    
     //const [base64PdfToUpload, setbase64PdfToUpload] = useState();
     const HandleChangeValue = (e) => {
         setSelectedRadio(e.target.value);
         if (e.target.value == 'Online'){
             document.getElementById("branch").value = ''
         }
     };
 
     function onChange(value) {
         if (value == null) {
             setverified(false);
         }
         else {
             setverified(true);
         }
     }
     const uploadDocument = async (event, type) => {
         const file = event.target.files[0];
         const base64 = await convertBase64(file);
         console.log(base64);
         const updloadFile = {
           "name": file.name,
           "type": file.type,
           "content": base64.split(",")[1],
           "base64": base64
         }
         if (type == "image") {
           setbase64ImageToUpload(updloadFile);
         }
         else if (type == "pdf") {
            setbase64PdfToUpload(updloadFile);
    }
       };

       const pdfMaxSize = 1048576; // 1MB

       const pdfUpload = (e) => {
            const file = e.target.files[0];
            if (file.size > pdfMaxSize) {
                setPdfError(true);
                setTimeout(() => setPdfError(false), 3000);
                document.getElementById("pdffile").value = "";
            } else {
                document.getElementById("pdfindex").value = e.target.files[0].name;
                setPdfName(file.name);
                uploadDocument(e, "pdf");
            }
       };

       //console.log(base64ImageToUpload); // Check if myObject is undefined
       //console.log(base64ImageToUpload?.base64); 
     const convertBase64 = (file) => {
         return new Promise((resolve, reject) => {
           const fileReader = new FileReader();
           fileReader.readAsDataURL(file);
     
           fileReader.onload = () => {
             resolve(fileReader.result);
           };
     
           fileReader.onerror = (error) => {
             reject(error);
           };
         });
       };
       
 
       const imageUpload = (e) => {
        const file = e.target.files[0]; // get the first selected file
        const maxSize = 1024 * 1024; // 1MB

        if (!file) return; // ✅ return early if no file is selected

        if (file.size > maxSize) {
            setimgerror(true);
            setTimeout(() => setimgerror(false), 3000);
            e.target.value = ""; // reset the input
        } else {
            setFileName(file.name); // store the file name in state
            uploadDocument(e, "image"); // your existing upload function
        }
        };

      // console.log(imageUpload);
       function convertJsonStringToNumber(jsonString) {
         // Parse the JSON string to an object
         const jsonObject = JSON.parse(jsonString);
       
         // Iterate over the keys and convert numeric strings to numbers
         for (const key in jsonObject) {
           if (jsonObject.hasOwnProperty(key)
     && !isNaN(jsonObject[key])) {
             jsonObject[key] = Number(jsonObject[key]);
           }
         }
       
         return jsonObject;
       }
     async function handleOnSubmit(e) {
         e.preventDefault();
      if (verified) {
             const formData = {};
             Array.from(e.currentTarget.elements).forEach(field => {
                 if (!field.name) return;
                 if (field.type === "radio") {
                     if (field.checked) {
                         formData[field.name] = field.value;
                     }
                 } else {
                     formData[field.name] = field.value;
                 }
             });
             formData['formType'] = "tnpscmainsiimocktest";
             formData['title'] = "TNPSC GR II/IIA Mains Mock Test Registration 2026";
             //formData['branch'] = props.branchname;
            formData["imagefile"] = base64ImageToUpload;       
            formData["pdfFile"]   = base64PdfToUpload;         

            formData["photo"] = base64ImageToUpload?.base64;  
            formData["pdf"]   = base64PdfToUpload?.base64;

            const testTitle = "TNPSC GR II/IIA Mains Mock Test Registration 2026";
           // const testFees = 100;
            //const modeOfTest = "Offline";

            // const paymentDatav ={
            //   testTitle,
            //   name: formData['name'],
            //   phoneNo: formData['phoneNo'],
            //   emailaddress: formData['emailaddress'],
            //   modeOfTest,
            //   testcenter: formData['testcentre'],
            //   community: formData['community'],
            //   testFees: testFees.toString()
            // };
            // setPaymentData(paymentDatav);
             delete formData["imagefile"];
             delete formData["filename"];
             delete formData["pdfFile"];
             delete formData["pdffile"];
 
            // formData['countryCode'] = "+91";
              formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
              formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
              const transform={fields:{...formData}};
              console.log(transform);
              tnpscmailcnfm(transform);
              setIsLoading(true);
              tnpscnewuser(transform)
                  .then(response => {
                  //sessionStorage.setItem('paymentForm', JSON.stringify(transform));
                  setModalOtp(true);
                  setmodalOtpstatus(response.message);
                  window.grecaptcha.reset(setverified);
                  setverified(false);
                  
                  //window.location.href = `https://admissionsv1.shankariasacademy.com/tnpscPayment/Paymentscreen?${(paymentData)}`;
                  setvaluephno(undefined);
                  document.getElementById("tnpscmainsiimocktest").reset();
                  setIsLoading(false);

                  })
                   .catch(error => {
                  setModalOtp(true);
                  setmodalOtpstatus("failure");
                  window.grecaptcha.reset(setverified);
                  setverified(false);
                  setIsLoading(false);
        })
      }
    else {
      setcaptchaerror(true);
      setTimeout(() => {
        setcaptchaerror(false);
      }, 3000);
    }
  
     }
    
  return (
  <>
    {isLoading &&
        <div class="APIPreLoader" id="APIPreLoader">
            <div class="loader">Loading...</div>
        </div>
    }
  <Otpverification show={modalOtp} title={modalOtpstatus} method="POST" action="index.js" frompage="tnpscmainsiimocktest" payment={paymentData} onHide={() => setModalOtp(false)} />
  <div className="container-fluid pt-3 " style={{ background: "#e2f6ff 0% 0% no-repeat padding-box", opacity: "1" }}>
    <div className="row mx-auto " >
        <div className="col">
          <div className="container pt-2">
              <div className="row">
                  <div className="col-12 mx-auto">
                    <h2 className={`${styles.tesfee} text-center`}>I'M TOP TNPSC Group II/IIA Mains State Level Mock Test 2026</h2>
                     <p className="pt-2"><sup className= {`${styles.dot}`}>*</sup> Registration is mandate for all the candidates (Both SIA Test Batch students 2025 and non-test batch students)<br/>
                      (Registered students alone will be admitted for the State Level TNPSC Group II/IIA Mains State Level Mock Test 2026)</p> 
                    <form onSubmit={handleOnSubmit} id="tnpscmainsiimocktest" autoComplete="off">
                        <div className="row pt-4">
                         <div className="col-12 col-xl-3 col-lg-4">
                            <div className="mb-4">
                               <select className={`${styles.acheiverrank} form-select form-control`} name="mocktestapplied" autoComplete="off" required>
                                    <option value="" disabled selected hidden>Select Mock Test Applied for</option>
                                    <option value="Both Group II and Group IIA Main ">Both Group II and Group IIA Main </option>
                                    <option value="Group II Main only ">Group II Main only </option>
                                     <option value="Group II Main only ">Group IIA Main only</option>
                                 
                                </select>
                            </div>
                        </div>

                        <div className="col-12 col-xl-3  col-lg-4">
                            <div className="mb-4">
                                <input type="text" className={`${styles.acheiverrank1} form-control`} placeholder="Name *" autoComplete="off" name="name" minLength="1" pattern="[A-Z\s]+" required onInput={(e) => {
                                e.target.value = e.target.value.toUpperCase(); }}  />
                            </div>
                        </div>
                         <div className="col-12 col-xl-3 col-lg-4">
                            <div className="mb-4">
                                <input type="tel" className={`${styles.acheiverrank1} form-control`} name="phoneNo" placeholder="Phone No *" pattern="[0-9]{10}" maxlength="10" required />
                            </div>
                        </div>               
                        <div className="col-12 col-xl-3 col-lg-4">
                            <div className="mb-4">
                                <input type="email" className={`${styles.acheiverrank1} form-control`} placeholder="Email Address *" title="Please enter a valid email address" autoComplete="off" name="emailaddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                            </div>
                        </div> 

                        

                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                            <label className={`${styles.mainsmock} form-check-label `}> Group II/IIA Prelims Reg No <sup className= {`${styles.dot}`}>*</sup></label>
                            <div className=" mb-4">
                                <input type="number" className={`${styles.acheiverrank1} form-control `} name="groupIIprelimsregistrationNo" placeholder=" " pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" maxlength="10" required />
                            </div>
                        </div> 

                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                            <label className={`${styles.mainsmock} form-check-label `}> Date of Birth <sup className= {`${styles.dot}`}>*</sup></label>
                            <div className="">
                                <input  type="date" className={`${styles.acheiverrank1} form-control`}  name="dateofbirth"  required />
                            </div>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                            <label label className={`${styles.acheiverrank1} form-check-label px-2`}> Gender <sup className= {`${styles.dot}`}>*</sup></label><br/>
                                <input className="form-check-input" type="radio"
                                    name="gender"
                                    value="male"
                                    id="male"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Male">Male</label>    
                                <input className="form-check-input" type="radio"
                                    name="gender"
                                    value="female"
                                    id="male"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Male">Female</label>
                                <input className="form-check-input" type="radio"
                                    name="gender"
                                    value="others"
                                    id="male"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Female">Others</label>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                            <div className="mb-4">
                               <select className={`${styles.acheiverrank} form-select form-control`} name="community" autoComplete="off" required>
                                    <option value="" disabled selected hidden>Select your community *</option>
                                    <option value="BC">BC</option>
                                    <option value="BCM">BCM</option>
                                    <option value="MBC/DNC">MBC/DNC</option>
                                    <option value="SC">SC </option>
                                    <option value="SCA">SCA </option>
                                    <option value="ST">ST</option>
                                    <option value="General">General</option>
                                </select>
                            </div>
                        </div>
  
                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Are you Student of Shankar IAS Academy?">Are you PSTM Candidate? <sup className= {`${styles.dot}`}>*</sup></label> <br/>
                                <input className="form-check-input" type="radio"
                                    name="pstmcandidate"
                                    value="yes"
                                    id="yes"
                                    required        
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Yes">Yes</label>
                                <input className="form-check-input" type="radio"
                                    name="pstmcandidate"
                                    value="no"
                                    id="no"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="No">No</label>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Are you Ex-service man?">Mode of Exam<sup className= {`${styles.dot}`}>*</sup></label> <br/>        
                                <input className="form-check-input" type="radio"
                                    name="modeofexam"
                                    value="online"
                                    id="online"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Yes">Online</label>
                                <input className="form-check-input" type="radio"
                                    name="modeofexam"
                                    value="offline"
                                    id="offline"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="No">Offline</label>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Are you disabled?">Are you disabled?<sup className= {`${styles.dot}`}>*</sup></label> <br/>
                                <input className="form-check-input" type="radio"
                                    name="disabled"
                                    value="yes"
                                    id="yes"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Yes">Yes</label>
                                <input className="form-check-input" type="radio"
                                    name="disabled"
                                    value="no"
                                    id="no"
                                    required
                                />
                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="No">No</label>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 pt-3">
                          <div className="mb-4">
                            <select className={`${styles.acheiverrank} form-select form-control`} name="nativedistrict" autoComplete="off" required>
                                <option value="" disabled selected hidden>Select your Native District  *</option>
                                <option value="Ariyalur ">Ariyalur </option>
                                <option value="Chengalpattu">Chengalpattu </option>
                                <option value="Chennai">Chennai</option>
                                <option value="Coimbatore">Coimbatore</option>
                                <option value="Cuddalore">Cuddalore</option>
                                <option value="Dharmapuri">Dharmapuri</option>
                                <option value="Dindigul">Dindigul</option>
                                <option value="Erode">Erode</option>
                                <option value="Kallakurichi">Kallakurichi</option>
                                <option value="Kanchipuram">Kanchipuram</option>
                                <option value="Kanniyakumari">Kanniyakumari</option>
                                <option value="Karur">Karur</option>
                                <option value="Krishnagiri">Krishnagiri</option>
                                <option value="Madurai">Madurai </option>
                                <option value="Mayiladuthurai">Mayiladuthurai</option>
                                <option value="Nagapattinam">Nagapattinam</option>
                                <option value="Namakkal">Namakkal</option>
                                <option value="Nilgiris">Nilgiris</option>
                                <option value="Perambalur">Perambalur</option>
                                <option value="Pudukkottai">Pudukkottai</option>
                                <option value="Ramanathapuram">Ramanathapuram</option>
                                <option value="Ranipet">Salem</option>
                                <option value="Sivagangai">Sivagangai</option>
                                <option value="Tenkasi">Tenkasi</option>
                                <option value="Thanjavur">Thanjavur</option>
                                <option value="Thoothukudi">Thoothukudi</option>
                                <option value="Tiruchirappalli">Tiruchirappalli</option>
                                <option value="Tirunelveli">Tirunelveli</option>
                                <option value="Tirupathur">Tirupathur</option>
                                <option value="Tiruppur">Tiruppur</option>
                                <option value="Tiruvallur">Tiruvallur</option>
                                <option value="Tiruvannamalai">Tiruvannamalai</option>
                                <option value="Tiruvarur">Tiruvarur</option>
                                <option value="Vellore">Vellore </option>
                                <option value="Viluppuram">Viluppuram</option>
                                <option value="Virudhunagar ">Virudhunagar</option>
                            </select>
                          </div>
                        </div>
                                    
                        <div className="col-12 col-xl-3  col-lg-4 pt-3">
                          <div className="mb-4">
                            <select className={`${styles.acheiverrank} form-select form-control`} name="testcentre" autoComplete="off" required>
                                <option value="" disabled selected hidden>Mock Test Centre *</option>
                                <option value="AnnaNagar-Chennai">AnnaNagar-Chennai</option>
                                <option value="Adyar-Chennai">Adyar-Chennai</option>
                                <option value="Salem">Salem</option>
                                <option value="Madurai">Madurai</option>
                                <option value="Trichy">Trichy</option>
                                <option value="Namakkal">Namakkal</option>
                                <option value="Thiruvarur">Thiruvarur</option>
                                <option value="Coimbatore">Coimbatore</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 pt-4">
                            <p>Are you student of Shankar IAS Academy? <sup className= {`${styles.dot}`}>*</sup></p>
                            <label className={`${styles.mainsmock} form-check-label px-2`}> </label>
                                <input className="form-check-input" type="radio"
                                    name="ifsia"
                                    value={"Yes"}
                                    id="IfSIAYes"
                                    required
                                    onChange={HandleChangeValue}  
                                />
                                <label className={`${styles.mainsmock} form-check-label px-2`} htmlFor="Online"> Yes</label>
                                    <input className="form-check-input" type="radio"
                                        name="ifsia"
                                        value={"No"}
                                        id="IfSIANo"
                                        required
                                       onChange={HandleChangeValue}
                                    />
                                    <label className={`${styles.mainsmock} form-check-label px-2`} htmlFor="Offline">No</label>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 pt-4">
                                        <label className={`${styles.mainsmock} form-check-label px-2 py-2`} htmlFor="Offline"> If yes, specify the programme name</label>
                                        <div className="mb-4">
                                       
                                        <input type="hidden" name="programme" value={formData.selectedData} />
                                        
                                        <MultiSelect
                                            options={options}
                                            value={selected}
                                            onChange={handleChange}
                                            labelledBy="Select"
                                            disabled={selectedRadio ===  'No' ? 'Yes' : ''}
                                            placeholder="If yes, specify the programme name"
                                           
                                        />
                                        </div>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 mb-3 pt-4">
                            <label
                                className={`${styles.mainsmock} form-check-label px-2 py-2`}
                                htmlFor="Offline"
                            >
                            Select your passport size photo<sup className= {`${styles.dot}`}>*</sup>
                            </label>
                            <div className="mb-4">
                                <div className="input-group d-block">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input
                                               type="text"
                                               id="fileindex"
                                               name="filename"
                                               className="form-control"
                                               placeholder="Photo"
                                               readOnly
                                               required
                                               style={{
                                                display: "none",
                                                }}
                                            />
                                            <span
                                                className="input-group-btn"
                                                style={{
                                                border: "1px solid #D9DFE6",
                                                backgroundColor: "#fff",
                                                borderRadius: "50%", 
                                                overflow: "hidden", 
                                                width: "104px",
                                                height: "100px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "-5px 69px",
                                                }}
                                            >
                                            <div className={`${styles.customFileUploader} btn btn-default`}>
                                                <input
                                                    type="file"
                                                    className={`${styles.selected}`}
                                                    name="imagefile"
                                                    id="imagefile"
                                                    onChange={(e) => imageUpload(e)}
                                                    accept="image/x-png,image/jpeg"
                                                    required
                                                    style={{
                                                    position: "absolute",
                                                    width: "80px",
                                                    height: "80px",
                                                    opacity: 0,
                                                    cursor: "pointer",
                                                    }}
                                                />
                                                <i className="bi bi-upload" style={{ fontSize: "24px" }}></i>
                                            </div>
                                        </span>
                                        </div>
                                    </div>
                                    
                                   {fileName && (
                                        <span className={`${styles.checkboxcontent} float-start text-primary mt-2`}>
                                            Uploaded: {fileName}
                                        </span>
                                    )}

                                    <span className={`${styles.checkboxcontent} float-start`}>
                                        Jpg/Png format, less than 1MB
                                    </span>
                                </div>
                                {imgerror && (
                                <div className="text-danger pt-1 captachafont">
                                     Please select a photo up to a size of 1 MB
                                </div>
                                )}
                            </div>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 mb-3 pt-4">
                            <label className={`${styles.mainsmock} form-check-label px-2 py-2`}>
                                Upload your Group II/IIA Main or Prelims Hall ticket<sup className={`${styles.dot}`}>*</sup>
                            </label>
                            <div className="mb-4">
                                <div className="input-group d-block">
                                <div className="form-group">
                                    <div className="input-group">
                                    <input
                                        type="text"
                                        id="pdfindex"
                                        name="pdffilename"
                                        className="form-control"
                                        placeholder="Upload PDF"
                                        readOnly
                                        required
                                        style={{ display: "none" }}
                                    />
                                    <span
                                        className="input-group-btn"
                                        style={{
                                        border: "1px solid #D9DFE6",
                                        backgroundColor: "#fff",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        width: "150px",
                                        height: "45px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        margin: "5px 60px",
                                        }}
                                    >
                                    <div className={`${styles.customFileUploader} btn btn-default`}>
                                        <input
                                            type="file"
                                            className={`${styles.selected}`}
                                            name="pdffile"
                                            id="pdffile"
                                            onChange={(e) => pdfUpload(e)}
                                            accept="application/pdf"
                                            required
                                            style={{
                                            position: "absolute",
                                            width: "150px",
                                            height: "45px",
                                            opacity: 0,
                                            cursor: "pointer",
                                            }}
                                        />
                                        <i className="bi bi-file-earmark-arrow-up" style={{ fontSize: "20px" }}></i>
                                        <span className="ps-2">Upload PDF</span>
                                    </div>
                                    </span>
                                    </div>
                                </div>

                                 {pdfName && (
                                        <span
                                        className={`${styles.checkboxcontent} float-start text-primary mt-2`}
                                        >
                                        Uploaded: {pdfName}
                                        </span>
                                )}


                                <span className={`${styles.checkboxcontent} float-start`}>
                                    PDF format only, less than 1 MB
                                </span>
                                </div>
                                {pdfError && (
                                <div className="text-danger pt-1 captachafont">
                                    Please upload a PDF up to a size of 1 MB
                                </div>
                                )}
                            </div>
                        </div>

                        <div className="col-12 col-xl-3 col-lg-4 mb-3 pt-4">
                            <div className="d-flex flex-column align-items-center align-items-md-start mt-2">
                                <ReCAPTCHA className={`${styles.captcha}`}
                                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                                    onChange={onChange}
                                />
                                <div className="">
                                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                                </div>
                            </div>  
                        </div>

                        <div className="col-12  col-xl-5 col-lg-8 mb-3 ">
                            <label  className={`${styles.mainsmock} form-check-label px-2 py-2`}>
                                <input className="form-check-input m-2" type="checkbox" name="Agree" value="yes" id={styles.invalidCheck2} required /> 
                                Declaration<sup className= {`${styles.dot}`}>*</sup>
                            </label>

                            <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                               I hereby declare that the data submitted by me for the State Level TNPSC Group II/IIA Mains Mock Test 2025 conducted by Shankar IAS Academy is true to the best of my knowledge. Also, I shall authorize the Shankar IAS Academy to use my candidature for any promotion purpose.
                            </label>
             
                        </div>

                        <div className="col-12  col-xl-1 col-lg-4  pt-5">
                                <button type="submit" className={`${styles.normalbutton}`}>Submit</button>
                        </div>
             
                        </div>
                    </form>
                  </div>
              </div>
          </div>
        </div>
    </div>
  </div>
  </>
  );
}
